import { Button, Flex, Input, Select } from '@chakra-ui/react';
import React, { useEffect, useState } from 'react';
import { Links } from '../page_calculator/components/links';
import { dataA, dataB, dataC, dataD, DataObject } from './RankingScoreTable';
import { placingScoreTable } from './PlacingScoreTable';

export const RankingScore = () => {
  // `Dec` に対して、`Dec` 以下の最大の `Dec` を持つ `Points` を返す
  const findClosestPoints = (data: DataObject, dec: number): number | null => {
    const entries = Object.entries(data).map(([key, value]) => ({
      points: parseInt(key, 10),
      dec: value,
    }));

    const filteredEntries = entries.filter((entry) => entry.dec <= dec);
    if (filteredEntries.length === 0) return null;

    const closestEntry = filteredEntries.reduce((prev, curr) =>
      curr.dec > prev.dec ? curr : prev
    );
    return closestEntry.points;
  };
  //placingScoreについて
  const [gradeA, setGradeA] = useState('');
  const [placeA, setPlaceA] = useState('');
  const [gradeB, setGradeB] = useState('');
  const [placeB, setPlaceB] = useState('');

  useEffect(() => {
    if (gradeA && placeA) {
      const score = placingScoreTable[gradeA]?.[placeA];
      if (score !== undefined) {
        setAdditionalNumberA(score.toString());
      }
    }
  }, [gradeA, placeA]);
  useEffect(() => {
    if (gradeB && placeB) {
      const score = placingScoreTable[gradeB]?.[placeB];
      if (score !== undefined) {
        setAdditionalNumberB(score.toString());
      }
    }
  }, [gradeB, placeB]);

  // **セットA**
  const [selectedDataA, setSelectedDataA] = useState<'A' | 'B' | 'C' | 'D'>(
    'A'
  );
  const [inputPointsA, setInputPointsA] = useState<string>('');
  const [inputDecA, setInputDecA] = useState<string>('');
  const [additionalNumberA, setAdditionalNumberA] = useState<string>('');

  // **セットB**
  const [selectedDataB, setSelectedDataB] = useState<'A' | 'B' | 'C' | 'D'>(
    'A'
  );
  const [inputPointsB, setInputPointsB] = useState<string>('');
  const [inputDecB, setInputDecB] = useState<string>('');
  const [additionalNumberB, setAdditionalNumberB] = useState<string>('');

  // **選択されたデータセットを取得**
  const getSelectedData = (selectedData: 'A' | 'B' | 'C' | 'D') => {
    switch (selectedData) {
      case 'A':
        return dataA;
      case 'B':
        return dataB;
      case 'C':
        return dataC;
      case 'D':
        return dataD;
      default:
        return dataA;
    }
  };

  // Points で検索（セットA）
  const handlePointsChangeA = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputPointsA(value);
    const selectedData = getSelectedData(selectedDataA);
    const number = parseInt(value, 10);
    if (!isNaN(number) && selectedData[number] !== undefined) {
      setInputDecA(selectedData[number].toString());
    } else {
      setInputDecA('');
    }
  };

  // Dec で検索（セットA）
  const handleDecChangeA = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputDecA(value);
    const selectedData = getSelectedData(selectedDataA);
    const number = parseInt(value, 10);
    if (!isNaN(number)) {
      const closestPoints = findClosestPoints(selectedData, number);
      if (closestPoints !== null) {
        setInputPointsA(closestPoints.toString());
      } else {
        setInputPointsA('');
      }
    } else {
      setInputPointsA('');
    }
  };

  // Points で検索（セットB）
  const handlePointsChangeB = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputPointsB(value);
    const selectedData = getSelectedData(selectedDataB);
    const number = parseInt(value, 10);
    if (!isNaN(number) && selectedData[number] !== undefined) {
      setInputDecB(selectedData[number].toString());
    } else {
      setInputDecB('');
    }
  };

  // Dec で検索（セットB）
  const handleDecChangeB = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.target.value;
    setInputDecB(value);
    const selectedData = getSelectedData(selectedDataB);
    const number = parseInt(value, 10);
    if (!isNaN(number)) {
      const closestPoints = findClosestPoints(selectedData, number);
      if (closestPoints !== null) {
        setInputPointsB(closestPoints.toString());
      } else {
        setInputPointsB('');
      }
    } else {
      setInputPointsB('');
    }
  };

  const LOCAL_STORAGE_KEY = 'RankingScoreData';
  const [isInitialized, setIsInitialized] = useState(false);

  useEffect(() => {
    const stored = localStorage.getItem('RankingScoreData');
    if (stored) {
      try {
        const data = JSON.parse(stored);

        if (data.inputPointsA) setInputPointsA(data.inputPointsA);
        if (data.inputDecA) setInputDecA(data.inputDecA);
        if (data.gradeA) setGradeA(data.gradeA);
        if (data.placeA) setPlaceA(data.placeA);
        if (data.additionalNumberA)
          setAdditionalNumberA(data.additionalNumberA);
        if (data.selectedDataA) setSelectedDataA(data.selectedDataA);

        if (data.inputPointsB) setInputPointsB(data.inputPointsB);
        if (data.inputDecB) setInputDecB(data.inputDecB);
        if (data.gradeB) setGradeB(data.gradeB);
        if (data.placeB) setPlaceB(data.placeB);
        if (data.additionalNumberB)
          setAdditionalNumberB(data.additionalNumberB);
        if (data.selectedDataB) setSelectedDataB(data.selectedDataB);
      } catch (e) {
        console.error('RankingScoreData 読み込み失敗:', e);
      }
    }

    setIsInitialized(true); // フラグを立ててから保存開始
  }, []);

  useEffect(() => {
    if (!isInitialized) return;

    const dataToSave = {
      inputPointsA,
      inputDecA,
      gradeA,
      placeA,
      additionalNumberA,
      selectedDataA,
      inputPointsB,
      inputDecB,
      gradeB,
      placeB,
      additionalNumberB,
      selectedDataB,
    };

    localStorage.setItem('RankingScoreData', JSON.stringify(dataToSave));
  }, [
    isInitialized,
    inputPointsA,
    inputDecA,
    gradeA,
    placeA,
    additionalNumberA,
    selectedDataA,
    inputPointsB,
    inputDecB,
    gradeB,
    placeB,
    additionalNumberB,
    selectedDataB,
  ]);

  const resetInputs = () => {
    setInputPointsA('');
    setInputDecA('');
    setGradeA('');
    setPlaceA('');
    setAdditionalNumberA('');
    setSelectedDataA('A');

    setInputPointsB('');
    setInputDecB('');
    setGradeB('');
    setPlaceB('');
    setAdditionalNumberB('');
    setSelectedDataB('A');
  };

  return (
    <div>
      <h1 style={{ fontWeight: 'bold', padding: '16px' }}>
        RankingScore計算サイト_混成用
      </h1>
      <Flex>
        <a
          href="https://worldathletics.org/world-ranking-rules/combined-events-2025"
          target="_blank"
          rel="noopener noreferrer"
          style={{ fontSize: '12px', padding: '16px' }}
        >
          <u>WA公式ページ</u>
        </a>{' '}
        <br />
        <Button
          size="xs"
          onClick={resetInputs}
          style={{
            marginLeft: '100px',
            marginTop: '10px',
          }}
          variant="solid"
          color="black"
        >
          Reset
        </Button>
      </Flex>
      <hr />
      {/* セット A */}
      <div
        style={{
          paddingLeft: '40px',
          backgroundColor: '#f9f9f9',
          padding: '16px',
        }}
      >
        <h2 style={{ paddingBottom: '8px' }}>Score_1</h2>
        <label></label>
        <Select
          size="xs"
          width="150px"
          value={selectedDataA}
          onChange={(e) =>
            setSelectedDataA(e.target.value as 'A' | 'B' | 'C' | 'D')
          }
        >
          <option value="A">Decathlon</option>
          <option value="B">Heptathlon_Indoor</option>
          <option value="C">Heptathlon</option>
          <option value="D">Pentathlon_Indoor</option>
        </Select>{' '}
        {/* <label>GameResult:</label> */}
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={inputDecA}
          onChange={handleDecChangeA}
          placeholder="Result(記録) を入力"
        />
        <br />
        {/* <label>ResultScore:</label> */}
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={inputPointsA}
          onChange={handlePointsChangeA}
          placeholder="ResultScore を入力"
        />
        <br />
        {/* <label>PlacingScore:</label> */}
        <Flex>
          {/* グレード選択 */}
          <Select
            size="xs"
            placeholder="大会"
            value={gradeA}
            onChange={(e) => setGradeA(e.target.value)}
            width="100px"
          >
            {Object.keys(placingScoreTable).map((grade) => (
              <option key={grade} value={grade}>
                {grade}
              </option>
            ))}
          </Select>
          {/* 順位選択 */}
          <Select
            size="xs"
            placeholder="順位"
            value={placeA}
            onChange={(e) => setPlaceA(e.target.value)}
            width="100px"
          >
            {Array.from({ length: 16 }, (_, i) => (
              <option key={i + 1} value={(i + 1).toString()}>
                {i + 1}位
              </option>
            ))}
          </Select>
        </Flex>
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={additionalNumberA}
          onChange={(e) => setAdditionalNumberA(e.target.value)}
          placeholder="PlacingScore を入力"
        />
        <br />
        <br />
        <strong>PerformanceScore:</strong>{' '}
        <strong>
          {' 　 '}
          {parseInt(inputPointsA || '0', 10) +
            parseInt(additionalNumberA || '0', 10)}
        </strong>{' '}
        <br />
      </div>
      <hr />
      {/* セット B */}
      <div style={{ paddingLeft: '40px', padding: '16px' }}>
        <h2 style={{ paddingBottom: '8px' }}>Score_2</h2>
        <Select
          size="xs"
          width="150px"
          value={selectedDataB}
          onChange={(e) =>
            setSelectedDataB(e.target.value as 'A' | 'B' | 'C' | 'D')
          }
        >
          <option value="A">Decathlon</option>
          <option value="B">Heptathlon_Indoor</option>
          <option value="C">Heptathlon</option>
          <option value="D">Pentathlon_Indoor</option>
        </Select>
        {/* <label>Dec:</label> */}
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={inputDecB}
          onChange={handleDecChangeB}
          placeholder="Result(記録) を入力"
        />
        <br />
        {/* <label>ResultScore:</label> */}
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={inputPointsB}
          onChange={handlePointsChangeB}
          placeholder="ResultScore を入力"
        />
        <br />
        {/* <label>追加数値:</label> */}
        <Flex>
          {/* グレード選択 */}
          <Select
            size="xs"
            placeholder="大会"
            value={gradeB}
            onChange={(e) => setGradeB(e.target.value)}
            width="100px"
          >
            {Object.keys(placingScoreTable).map((grade) => (
              <option key={grade} value={grade}>
                {grade}
              </option>
            ))}
          </Select>
          {/* 順位選択 */}
          <Select
            size="xs"
            placeholder="順位"
            value={placeB}
            onChange={(e) => setPlaceB(e.target.value)}
            width="100px"
          >
            {Array.from({ length: 16 }, (_, i) => (
              <option key={i + 1} value={(i + 1).toString()}>
                {i + 1}位
              </option>
            ))}
          </Select>
        </Flex>
        <Input
          width="200px"
          type="number"
          inputMode="numeric"
          value={additionalNumberB}
          onChange={(e) => setAdditionalNumberB(e.target.value)}
          placeholder="PlacingScoreを入力"
        />
        <br /> <br />
        <strong>PerformanceScore:</strong>{' '}
        <strong>
          {' 　 '}
          {parseInt(inputPointsB || '0', 10) +
            parseInt(additionalNumberB || '0', 10)}
        </strong>{' '}
      </div>
      <hr />
      <div style={{ backgroundColor: '#f9f9f9', padding: '16px' }}>
        <br />
        <strong>
          RankingScore:　
          {Math.floor(
            (parseInt(inputPointsA || '0', 10) +
              parseInt(additionalNumberA || '0', 10) +
              parseInt(inputPointsB || '0', 10) +
              parseInt(additionalNumberB || '0', 10)) /
              2
          )}
        </strong>
        <br /> <br />
      </div>
      <hr />
      <Links />
    </div>
  );
};
